export default "__VITE_ASSET__e8a2e54c__"